export const TESTCOMPONENT_CONTAINER = 'CollageType2-TextContainer';
export const TESTCOMPONENT_HEADING = 'CollageType2-TextHeading';
export const COMPONENT_NAME = 'CollageType2';
